var groupedProductInputs = document.querySelectorAll('[data-grouped-product-quantity]');
var addToCartBtn = document.querySelector('[data-add-to-cart]');

groupedProductInputs.forEach(function(groupedProductInput) {
  groupedProductInput.addEventListener('change', function(e) {
    var totalGroupedProducts = 0;

    groupedProductInputs.forEach(function(input) {
      totalGroupedProducts += parseInt(input.value);
    });

    if (totalGroupedProducts) {
      addToCartBtn.disabled = false;
    } else {
      addToCartBtn.disabled = true;
    }
  });
});

if (groupedProductInputs.length > 0) {
  addToCartBtn.addEventListener('click', function(e) {
    e.preventDefault();

    var items = [];
    var totalItems = 0;

    groupedProductInputs.forEach(function(input) {
      var variantId = input.getAttribute('data-grouped-product-quantity');

      if (input.value >= 1) {
        var variant = {
          id: variantId,
          quantity: parseInt(input.value)
        }

        var preorderMsg = document.querySelector('[data-backorder-property="'+variantId+'"]').value
        
        if (preorderMsg != '') {
          variant['properties'] = {
            'Pre-order': preorderMsg
          }
        }

        items.push(variant);

        totalItems += parseInt(input.value);
      }
    });

    if (totalItems == 0) return false;

    let formData = {
      'items': items
     };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (response.ok) location.href = '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });
}

var minimumOrderQtys = document.querySelectorAll('[data-min-quantity]');

minimumOrderQtys.forEach(function(minimumOrderQty) {
  minimumOrderQty.addEventListener('change', function(e) {
    var minimum = minimumOrderQty.getAttribute('data-min-quantity');
    var value   = parseInt(minimumOrderQty.value);

    if (value < minimum) {
      minimumOrderQty.value = minimum;
      e.preventDefault();
    }
  });
});